__webpack_require__.p = "/offer-content-generator-stop-generating/referrals-hub/";